// extracted by mini-css-extract-plugin
module.exports = {"refDiv":"BottomMenu_refDiv__MNNu_","dividerDiv":"BottomMenu_dividerDiv__ibg4y"};